import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M17.657 11a6 6 0 1 0 -11.315 0","key":"svg-0"}],["path",{"d":"M6.342 11l5.658 11l5.657 -11l-11.315 0","key":"svg-1"}]]

/**
 * IconIceCream2
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItaWNlLWNyZWFtLTIiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTE3LjY1NyAxMWE2IDYgMCAxIDAgLTExLjMxNSAwIiAvPgogIDxwYXRoIGQ9Ik02LjM0MiAxMWw1LjY1OCAxMWw1LjY1NyAtMTFsLTExLjMxNSAwIiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/ice-cream-2
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconIceCream2 = createReactComponent('outline', 'ice-cream-2', 'IceCream2', __iconNode);

export default IconIceCream2;